export const ITEM_SIZE = 36.5
